import { Flex, IconButton } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import { InputFilter } from "../../../../components/filter/inputFilter";
import { RiCloseFill, RiFileExcel2Fill, RiFilterLine } from "react-icons/ri";
import { URL_WEB } from "../../../../utils/utils";
import { useAuth } from "../../../../hooks/useAuth";

type Props = {
  fleetId: string;
};

export function FilterDatailMileage({ fleetId }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();

  const { user } = useAuth();

  const start_date = searchParams.get("start_date");
  const end_date = searchParams.get("end_date");

  const [startDate, setStartDate] = useState(start_date ?? "");
  const [endDate, setEndDate] = useState(end_date ?? "");
  function handleFilter() {
    setSearchParams((state) => {
      if (startDate) {
        state.set("start_date", startDate);
      } else {
        state.delete("start_date");
      }

      if (endDate) {
        state.set("end_date", endDate);
      } else {
        state.delete("end_date");
      }

      return state;
    });
  }

  function handleClear() {
    setSearchParams((state) => {
      state.delete("start_date");
      setStartDate("");

      state.delete("end_date");
      setEndDate("");
      return state;
    });

    window.location.reload();
  }

  return (
    <Flex gap="1">
      <InputFilter
        width="200px"
        type="date"
        label="DATA INÍCIO:"
        name="start_date"
        value={startDate}
        onChange={(e) => {
          setStartDate(e.target.value);
        }}
      />
      <InputFilter
        width="200px"
        type="date"
        label="DATA FINAL:"
        name="end_date"
        value={endDate}
        onChange={(e) => {
          setEndDate(e.target.value);
        }}
      />

      {startDate && endDate && (
        <>
          <IconButton
            ml={3}
            mt={7}
            aria-label="Filtro"
            icon={<RiFilterLine />}
            onClick={handleFilter}
          />
          <IconButton
            mt={7}
            aria-label="Limpar"
            colorScheme="red"
            variant="outline"
            onClick={handleClear}
            icon={<RiCloseFill />}
          />
          <IconButton
            mt={7}
            aria-label="Excel"
            colorScheme="teal"
            variant="outline"
            as="a"
            target="_blank"
            href={`${URL_WEB}/company/report/mileagecar?user_id=${
              user.id
            }&start_date=${start_date ?? ""}&end_date=${
              end_date ?? ""
            }&fleet_id=${fleetId}`}
            icon={<RiFileExcel2Fill />}
          />
        </>
      )}
    </Flex>
  );
}
